"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var config = {
    lineNumbers: false
};
exports.config = config;
var setConfig = function (customConfig) {
    return (exports.config = config = Object.assign(config, customConfig));
};
exports.setConfig = setConfig;
var PLUGIN_NAME = 'code_block';
exports.PLUGIN_NAME = PLUGIN_NAME;
//# sourceMappingURL=config.js.map